(() => {
  const button = document.getElementById('oc-chat-launcher');
  const fallback = document.getElementById('oc-chat-fallback');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  // Reserve the actual visible purchase-bar height for both floating entry points.
  const bars = [...document.querySelectorAll('.ocu-sticky,[data-craft-sticky],.oc-mobile-bag')];
  const updateClearance = () => {
    let clearance = 0;
    if (window.innerWidth <= 767) bars.forEach(bar => {
      const rect = bar.getBoundingClientRect(), css = getComputedStyle(bar);
      if (!bar.hidden && css.display !== 'none' && css.visibility !== 'hidden' && rect.height && rect.top < window.innerHeight && rect.bottom > 0)
        clearance = Math.max(clearance, window.innerHeight - rect.top);
    });
    document.documentElement.style.setProperty('--oc-buy-clearance', Math.ceil(clearance) + 'px');
  };
  const barResize = new ResizeObserver(updateClearance);
  const barState = new MutationObserver(updateClearance);
  bars.forEach(bar => {
    barResize.observe(bar);
    barState.observe(bar, { attributes: true, attributeFilter: ['hidden','class','style'] });
  });
  window.addEventListener('resize', updateClearance, { passive: true });
  updateClearance();
  // The teaser is inside Shopify Forms' shadow root. Move only its collapsed state.
  const positionTeaser = () => {
    const embeds = [...document.querySelectorAll('shopify-forms-embed')];
    let found = false;
    embeds.forEach(embed => {
      const root = embed.shadowRoot;
      if (!root || !root.querySelector('[data-form-root]')) return;
      found = true;
      if (root.querySelector('#oc-floating-clearance')) return;
      const style = document.createElement('style');
      style.id = 'oc-floating-clearance';
      style.textContent = '@media(max-width:767px){[data-form-root][data-current-step="tease"]{bottom:calc(var(--oc-buy-clearance,0px) + 76px + env(safe-area-inset-bottom))!important}}';
      root.appendChild(style);
    });
    return found;
  };
  if (!positionTeaser()) {
    let attempts = 0;
    const timer = setInterval(() => { if (positionTeaser() || ++attempts >= 120) clearInterval(timer); }, 500);
    window.addEventListener('pagehide', () => clearInterval(timer), { once: true });
  }
  const label = button.querySelector('span');
  let loading = false, ready = false, requestedOpen = false, timeout;
  function remember(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  function recalled(key) { try { return sessionStorage.getItem(key) === '1'; } catch (_) { return false; } }
  function onReady() {
    if (ready || !window.tidioChatApi) return;
    ready = true;
    clearTimeout(timeout);
    button.hidden = true;
    fallback.hidden = true;
    button.removeAttribute('aria-busy');
    window.tidioChatApi.on('open', () => remember('oc-chat-open', '1'));
    window.tidioChatApi.on('close', () => remember('oc-chat-open', '0'));
    if (requestedOpen || recalled('oc-chat-open')) {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    }
  }
  function loadChat(open) {
    requestedOpen = requestedOpen || open;
    if (ready) { if (open) window.tidioChatApi.open(); return; }
    if (loading) return;
    loading = true;
    label.textContent = 'Loading chat…';
    button.setAttribute('aria-busy', 'true');
    document.addEventListener('tidioChat-ready', onReady, { once: true });
    if (window.tidioChatApi) window.tidioChatApi.on('ready', onReady);
    timeout = setTimeout(() => { if (!ready) { fallback.hidden = false; label.textContent = 'Loading chat…'; } }, 15000);
    let script = document.querySelector('script[src^="https://code.tidio.co/hzykcsiybakai4z8ow4cwnnjyjp86h2g.js"]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://code.tidio.co/hzykcsiybakai4z8ow4cwnnjyjp86h2g.js?extensionVersion=1.4.1';
      script.async = true;
      script.addEventListener('error', () => {
        loading = false;
        clearTimeout(timeout);
        script.remove();
        button.removeAttribute('aria-busy');
        label.textContent = 'Retry chat';
        fallback.hidden = false;
      }, { once: true });
      document.body.appendChild(script);
    }
  }
  button.hidden = false;
  button.addEventListener('click', () => { remember('oc-chat-used', '1'); loadChat(true); });
  // Once requested, restore the widget on subsequent pages in this tab.
  if (recalled('oc-chat-used')) {
    const restore = () => loadChat(false);
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore, { once: true });
  }
})();
